import * as React from 'react';
import { mergeClasses } from '../constants';
import Panel from './Panel';
import './ScorePanel.scss';

type Props = {
  change?: React.ReactNode;
  children: React.ReactNode;
  icon: React.ReactNode;
  score: React.ReactNode;
  title?: React.ReactNode;
  className?: string;
};

export default class ScorePanel extends React.Component<Props> {
  render() {
    const { change, children, icon, score, title, className } = this.props;
    return (
      <Panel className={mergeClasses(['dashboard-row', className])}>
        {title && <h2 className="mb-4">{title}</h2>}
        <div className="score-panel-body">
          <div className="score-panel-icon">{icon}</div>
          <div className="score-panel-score ml-4">{score}</div>
        </div>
        {change && <div className="score-panel-change">{change}</div>}
        <div className="score-panel-footer mt-4">{children}</div>
      </Panel>
    );
  }
}
